import { makeModuleStateSelector } from "@client/content/selectors";
import { getMultiselectValue } from "@client/lib/settings";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { intersection } from "lodash";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type Forums } from "./types";

export const localStateSelector = makeModuleStateSelector<Forums.AppState>(defaultState, previewState);

const makeForumOptionsLocalStateSelector = () => {
  return createSelector([localStateSelector], (localState) => localState.forumOptions);
};

export const makeForumOptionsSelector = () => {
  const forumOptionsSelector = makeForumOptionsLocalStateSelector();
  const forumSelector = getSettingValueSelector(TargetSelector.Entity, "forum", undefined, getMultiselectValue);

  return createSelector([forumOptionsSelector, forumSelector], (forumOptions, forum): Forums.Api.ForumOptionItem[] => {
    // exclude deleted forums if any
    const knownForumIds = intersection(
      forum,
      forumOptions.map((y) => y.value)
    );
    if (knownForumIds.length) {
      return forumOptions.filter((x) => knownForumIds.includes(x.value));
    }
    return forumOptions;
  });
};
